module.exports = __webpack_public_path__ + "img/share-help-btn.5b4f8292.svg";